import { AdviserWizardStoreStatic } from "./AdviserWizardStoreStatic";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const AdviserWizardDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AdviserWizardStore: AdviserWizardStoreStatic = new AdviserWizardStoreStatic();
